import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./component/loader.component";
import {
  MatProgressBarModule,
  MatProgressSpinnerModule,
} from "@angular/material";
import { LoaderService } from "./service/loader.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoaderInterceptor } from "../interceptor/loader.interceptor";

@NgModule({
  declarations: [LoaderComponent],
  imports: [CommonModule, MatProgressBarModule],
  exports: [LoaderComponent],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
})
export class LoaderModule {}
